import React, {useContext, useState} from "react";
import {DraftContext} from "../../../draftSave/context/DraftSaveContext";
import Row from "@amzn/meridian/row";
import Modal, {ModalFooter} from "@amzn/meridian/modal";
import {getLocalizedMessage} from "../../../util/Localization";
import Text from "@amzn/meridian/text";
import Column from "@amzn/meridian/column";
import Select, {SelectOption} from "@amzn/meridian/select";
import Button from "@amzn/meridian/button";
import Icon from "@amzn/meridian/icon";
import trashTokens from "@amzn/meridian-tokens/base/icon/trash";
import escapeRegExp from "lodash/escapeRegExp"
import {injectIntl} from "react-intl";
import {CONFIG_TYPE} from "../../../util/Constants";

const DeleteZancaSortLocationConfigurationModal = (props) => {

    const {getDraftData, deleteInstance, deleteAll} = useContext(DraftContext);
    const {open, setOpen, mac, intl} = props;
    const [selectedLocationId, setSelectedLocationId] = useState("")
    const [searchQuery, setSearchQuery] = useState("")

    const locationIdList = getDraftData({
        stateKey: CONFIG_TYPE.ZANCA_SORT_LOCATION_CONFIGURATION,
        subKey: mac
    }).map(({locationId}) => locationId);

    const searchRegExp = new RegExp(escapeRegExp(searchQuery), "i")
    const matchedKeys = locationIdList.filter(
        option => !searchQuery || searchRegExp.test(option)
    )

    const deleteData = () => {
        deleteInstance({
            stateKey: CONFIG_TYPE.ZANCA_SORT_LOCATION_CONFIGURATION,
            subKey: mac,
            keyComparator: (instance) => instance.locationId === selectedLocationId
        });
    }

    const onClickConfirm = () => {
        deleteData();
        setOpen(false)
        resetInputState();
    }

    function resetInputState() {
        setSelectedLocationId("");
    }

    const onCloseModal = () => {
        setOpen(false);
        resetInputState();
    }

    return (
        <Row>
            <Modal
                title={getLocalizedMessage({intl, stringId: "locationconfig.deleteconfig"})}
                open={open}
                onClose={onCloseModal}
                scrollContainer="viewport"
                closeLabel="Close"
                bodySpacingInset="medium">
                <Text tag="label" type="b200" color="primary" htmlFor="my-input">
                    {getLocalizedMessage({intl, stringId: "modal.delete_location_config"})}
                </Text>
                <Column spacing={"medium"} spacingInset={"medium"}>
                    <Select
                        value={selectedLocationId}
                        onChange={setSelectedLocationId}
                        searchQuery={searchQuery}
                        onSearch={setSearchQuery}
                        placeholder={getLocalizedMessage({intl, stringId: "locationconfig.delete"})}
                        width="100%">
                        {matchedKeys.map((locationId) =>
                            <SelectOption key={locationId} value={locationId} label={locationId}/>
                        )}
                        {!matchedKeys.length ? (
                            <Column alignmentVertical="center" spacing="100" spacingInset="100">
                                {locationIdList.length ?
                                    <Text alignment="center">
                                        {getLocalizedMessage({intl, stringId: "testconfig.nomatch"})}
                                    </Text>
                                    : <Text alignment="center">
                                        {getLocalizedMessage({intl, stringId: "testconfig.notavailable"})}
                                    </Text>
                                }
                            </Column>) : null}
                    </Select>
                </Column>
                <ModalFooter>
                    <Row alignmentHorizontal="justify" widths="fit">
                        <Button
                            size="small"
                            className="redBtn"
                            onClick={() => {
                                deleteAll({stateKey: CONFIG_TYPE.ZANCA_SORT_LOCATION_CONFIGURATION, subKey: mac});
                                onCloseModal();
                            }}>
                            <Icon tokens={trashTokens} />
                            {getLocalizedMessage({intl, stringId: "modal.deleteAll"})}
                        </Button>
                        <Row alignmentHorizontal="right" widths="fit">
                            <Button type="secondary" size="small" onClick={onCloseModal}>
                                {getLocalizedMessage({intl, stringId: "modal.cancel"})}
                            </Button>
                            <Button type="primary" size="small" onClick={onClickConfirm}>
                                {getLocalizedMessage({intl, stringId: "modal.confirm"})}
                            </Button>
                        </Row>
                    </Row>
                </ModalFooter>
            </Modal>
        </Row>
    )

}

export default injectIntl(DeleteZancaSortLocationConfigurationModal)



// WEBPACK FOOTER //
// ./src/components/devicemanagement/zancasort/modal/DeleteZancaSortLocationConfigurationModal.js